'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-block;\n  line-height: ', 'px;\n'], ['\n  display: inline-block;\n  line-height: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  padding: 8px 16px;\n  line-height: 28px;\n  margin: 0 !important;\n  box-shadow: 0px 3px 10px -1px rgba(0,0,0,0.2);\n  cursor: pointer;\n\n\n  &:first-child {\n    padding-left: 15px;\n    border-top-left-radius: 50px;\n    border-bottom-left-radius: 50px;\n  }\n  &:last-child {\n    padding-right: 15px;\n    border-top-right-radius: 50px;\n    border-bottom-right-radius: 50px;\n  }\n\n  color: ', ';\n\n  background: ', ';\n  color: ', ';\n\n'], ['\n  padding: 8px 16px;\n  line-height: 28px;\n  margin: 0 !important;\n  box-shadow: 0px 3px 10px -1px rgba(0,0,0,0.2);\n  cursor: pointer;\n\n\n  &:first-child {\n    padding-left: 15px;\n    border-top-left-radius: 50px;\n    border-bottom-left-radius: 50px;\n  }\n  &:last-child {\n    padding-right: 15px;\n    border-top-right-radius: 50px;\n    border-bottom-right-radius: 50px;\n  }\n\n  color: ', ';\n\n  background: ', ';\n  color: ', ';\n\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LinksWrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.lineHeight;
});

// .icon {
//   width: ${props => Math.round(props.theme.size[props.size] * 1.25)}px;
//   height: ${props => Math.round(props.theme.size[props.size] * 1.25)}px;
// }
LinksWrapper.displayName = 'LinksWrapper';
var Icon = _styledComponents2.default.span(_templateObject2, function (props) {
  return props.theme.color.base3;
}, function (props) {
  return props.active && props.theme.color[props.variant];
}, function (props) {
  return props.active && props.theme.color.white;
});

Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: '1'
};

var NitroIconTabs = function NitroIconTabs(props) {
  var data = props.data,
      active = props.active,
      variant = props.variant,
      lineHeight = props.lineHeight,
      action = props.action,
      disabled = props.disabled;


  var links = data.map(function (link, index) {
    var isLinkActive = link.label === active;
    if (link.value) {
      isLinkActive = link.value === active;
    }

    var handleLinkClick = function handleLinkClick() {
      if (disabled) return;

      if (link.url) window.open(link.url, '_blank');
      if (link.action) {
        link.action(link);
      }
      if (action) action(link);
    };

    var icon = _react2.default.createElement(
      Icon,
      {
        key: index,

        active: isLinkActive,
        variant: variant,
        onClick: handleLinkClick
      },
      _react2.default.createElement(_nitroIcon2.default, { size: 20, name: link.icon, variant: isLinkActive ? 'white' : 'base3', action: handleLinkClick })
    );

    return icon;
  });

  return _react2.default.createElement(
    LinksWrapper,
    { lineHeight: lineHeight },
    links
  );
};

NitroIconTabs.propTypes = {
  data: _propTypes2.default.array,
  active: _propTypes2.default.string,
  variant: _propTypes2.default.string,
  lineHeight: _propTypes2.default.number,
  action: _propTypes2.default.func,
  disabled: _propTypes2.default.bool
};

exports.default = NitroIconTabs;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon-tabs/NitroIconTabs.js
// module id = 2913
// module chunks = 4